import {
  Alert,
  Button,
  DeleteIcon,
  LinkIcon,
  Menu,
  MoreIcon,
  Space,
} from "melco-ui";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { useDeleteDesignCollections } from "../../../hooks/libraries/designCollections/useDeleteDesignCollections";
import { useShouldShowWarning } from "../../../hooks/items/useShouldShowWarning";
import { SharedserviceMelcoModelsDesignCollection, useConfirm } from "melco-shared-logic";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";

type DesignCollectionDetailMoreActionButtonProps = {
  designCollection: SharedserviceMelcoModelsDesignCollection;
  referencesDrawer?: DrawerType;
};

export const DesignCollectionDetailMoreActionButton: React.FC<
  DesignCollectionDetailMoreActionButtonProps
> = ({ designCollection, referencesDrawer }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const deleteDesignCollections = useDeleteDesignCollections();
  const shouldShowWarning = useShouldShowWarning();

  const confirmDelete = useConfirm(
    async () => {
      if (designCollection.id) {
        const successfullyDeletedIds = await deleteDesignCollections([
          designCollection.id,
        ]);

        // redirect to list view in case the entity was deleted successfully
        if (!isEmpty(successfullyDeletedIds)) {
          navigate(`/libraries/design-collections`);
        }
      }
    },
    {
      translationPrefix: "libraries.design_collections.actions.delete",
      translationOptions: {
        count: 1,
      },
      content: shouldShowWarning(designCollection) && (
        <Space direction="vertical" size="small">
          {t(
            "libraries.design_collections.actions.delete.confirmation.message",
            {
              count: 1,
            }
          )}
          <Alert
            type="warning"
            withBackground
            description={t(
              "libraries.design_collections.actions.delete.confirmation.warning",
              {
                count: 1,
              }
            )}
            showIcon={false}
          />
        </Space>
      ),
    }
  );

  const MoreActions = (
    <Menu>
      {referencesDrawer && (
        <Menu.Item
          key="more-actions-references"
          onClick={() => {
            referencesDrawer.openDrawer();
          }}
        >
          <LinkIcon />{" "}
          {t("libraries.design_collections.actions.references.button")}
        </Menu.Item>
      )}
      <Menu.Item
        key="more-actions-delete"
        danger
        onClick={() => {
          confirmDelete();
        }}
      >
        <DeleteIcon /> {t("libraries.design_collections.actions.delete.button")}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={MoreActions}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Button
        key="designs-more-actions"
        icon={<MoreIcon />}
        data-cy-id="designs-more-actions"
      />
    </Dropdown>
  );
};
